import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, Draggable);

document.addEventListener('DOMContentLoaded', () => {

    // Fade up elements animation
    const fadeUpElements = document.querySelectorAll('.anmi-fadeup');
    fadeUpElements.forEach((element, index) => {
        gsap.fromTo(element,
            { opacity: 0, y: 50 },
            {
                scrollTrigger: {
                    trigger: element,
                    start: 'top 80%',
                    toggleActions: 'play none none none',
                },
                duration: 1.5,
                opacity: 1,
                y: 0,
                ease: 'power2.out',
                delay: index * 0.25
            }
        );
    });

    // Fade left elements animation
    const fadeLeftElements = document.querySelectorAll('.anmi-fadeleft');
    fadeLeftElements.forEach((element, index) => {
        gsap.fromTo(element,
            { opacity: 0, x: -50 },
            {
                scrollTrigger: {
                    trigger: element,
                    start: 'top 80%',
                    toggleActions: 'play none none none',
                },
                duration: 1,
                opacity: 1,
                x: 0,
                ease: 'power2.out',
                delay: index * 0.15
            }
        );
    });

    // Fade bottom elements animation
    const fadeBottomElements = document.querySelectorAll('.anmi-fadebottom');
    fadeBottomElements.forEach((element, index) => {
        gsap.fromTo(element,
            { opacity: 0, y: 50 },
            {
                scrollTrigger: {
                    trigger: element,
                    start: 'top 80%',
                    toggleActions: 'play none none none',
                },
                duration: 1,
                opacity: 1,
                y: 0,
                ease: 'power2.out',
                delay: index * 0.15
            }
        );
    });

    // Staggered fade-in-up for groups (e.g. card loops)
    // Add .anmi-stagger to the parent; direct children animate in together
    document.querySelectorAll('.anmi-stagger').forEach((group) => {
        gsap.fromTo(group.children,
            { opacity: 0, y: 24 },
            {
                scrollTrigger: {
                    trigger: group,
                    start: 'top 85%',
                    toggleActions: 'play none none none',
                },
                duration: .75,
                opacity: 1,
                y: 0,
                ease: 'power2.out',
                stagger: 0.15,
            }
        );
    });

    // Text slide — horizontal scroll linked to scroll position
    const textslides = document.querySelectorAll('.textslide');
    textslides.forEach((section) => {
        const track = section.querySelector('.textslide__track');
        if (!track) return;

        // Distance to travel: the full track width minus the viewport width,
        // so the strip scrolls from its natural start position to fully off-screen left.
        const getDistance = () => -(track.scrollWidth - section.offsetWidth) * 0.4;

        gsap.to(track, {
            x: getDistance,
            ease: 'none',
            scrollTrigger: {
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                scrub: 2,
                invalidateOnRefresh: true,
            },
        });
    });

});

export default function initInitGsap() {
    gsap.registerPlugin(ScrollTrigger, Draggable);
}
